import * as React from "react";
import { FunctionComponent } from "react";
import Box from "@mui/material/Box";
import { InstitutionNavMenu } from "./institutionNavMenu";
import { TopNav } from "../common/top-nav/top-nav";
import { SchoolHelp } from "./schoolHelp";

export const Inistitution = (element: any): JSX.Element => {
  const [helpOpen, setHelpOpen] = React.useState(false);

  return (

    <>

      <TopNav onHelpClick={() => setHelpOpen(true)} />

      <Box
        component="main"
        sx={{
          bgcolor: "#f5f5f5",
          flexGrow: 1,
          height: "100vh",
          overflow: "hidden",
        }}
      >

        <Box sx={{ display: 'flex', height: '100%', paddingTop: '80px' }}>

          <InstitutionNavMenu />
          <Box className="content-container" sx={{ flexGrow: 1, minWidth: 0, pt: 2.5, pb: 2.5, px: 3, height: '100%', overflow: 'hidden' }}>
            {element.children}
          </Box>

        </Box>


      </Box>

      {/* <SchoolHelp open={helpOpen} onClose={() => setHelpOpen(false)} /> */}

    </>

  );
};
